import React from 'react';
import { Button } from "@/components/ui/button";
import { Grid, Pencil, Trash2 } from "lucide-react";
import { BoardList } from './BoardList';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { useNavigate } from 'react-router-dom';

interface WorkspaceListProps {
  workspaces: Array<{
    id: string;
    name: string;
    boards: Array<{
      id: string;
      name: string;
    }>;
  }>;
  onRename: (type: 'organization' | 'workspace' | 'board', id: string, name: string) => void;
  onDelete: (type: 'organization' | 'workspace' | 'board', id: string, name: string) => void;
}

export const WorkspaceList: React.FC<WorkspaceListProps> = ({
  workspaces,
  onRename,
  onDelete,
}) => {
  const navigate = useNavigate();

  const handleWorkspaceClick = (workspaceId: string) => {
    navigate('/dashboard', { state: { selectedWorkspace: workspaceId } });
  };

  return (
    <div className="space-y-2">
      {workspaces?.map((workspace) => (
        <Collapsible key={workspace.id}>
          <div className="flex items-center justify-between">
            <CollapsibleTrigger 
              className="flex items-center gap-2 w-full px-4 py-1.5 text-sm hover:bg-accent cursor-pointer"
              onClick={() => handleWorkspaceClick(workspace.id)}
            >
              <Grid className="h-4 w-4" />
              <span>{workspace.name}</span>
            </CollapsibleTrigger>
            <div className="flex gap-2">
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onRename('workspace', workspace.id, workspace.name)}
              >
                <Pencil className="h-4 w-4" />
              </Button>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onDelete('workspace', workspace.id, workspace.name)}
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </div>
          <CollapsibleContent className="pl-8">
            <BoardList
              boards={workspace.boards}
              onRename={onRename}
              onDelete={onDelete}
            />
          </CollapsibleContent>
        </Collapsible>
      ))}
    </div>
  );
};